
import Conexion_api from "@/api/Conexion_api.js"
import Usuario from "@/objetos/usuario";
import Manejador_sesiones from '@/funciones/manejador_sesiones'

const Login_cookie = function() {
    let sesion = {}
    return new Promise((resuelve,rechaza) => {
        const cookie = this.$cookie.get('pwst')
        if(cookie){
            Conexion_api({
                evento: "login/datos_sesion"
            }).then(function (respuesta){
                if(respuesta.data.error){
                    console.error(respuesta.data.error)
                    return rechaza(false)
                }
                sesion.tipo = respuesta.data.tipo;
                Usuario.nombre = respuesta.data.nombre
                Usuario.nombre_vista = respuesta.data.nombre
                Usuario.correo = respuesta.data.correo;
                Usuario.direccion = respuesta.data.direccion;
                Usuario.rut = respuesta.data.rut;
                Usuario.coordenadas = respuesta.data.coordenadas;
                Usuario.tiempo_sesion = Number(respuesta.data.segundos_restantes) * 1000
                Usuario.direccion_soporte = respuesta.data.direccion_soporte;

                this.manejador_sesiones = Manejador_sesiones.bind(this)
                this.manejador_sesiones()

                return resuelve(true)
            }.bind(this)).catch(err => {
                console.error(err);
                return rechaza(false)
            })
        } else {
            return resuelve(false)
        }
    })
}

export default Login_cookie
